
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9 15.75c.086 0 .653-.145 1.286-1.537.284-.624.524-1.393.693-2.267a35.835 35.835 0 0 1-3.958 0c.17.874.41 1.643.693 2.267.633 1.392 1.2 1.537 1.286 1.537Zm0-5.25a34 34 0 0 0 2.189-.07 16.511 16.511 0 0 0-.013-2.996 35.597 35.597 0 0 1-4.352 0 16.452 16.452 0 0 0-.013 2.997A34 34 0 0 0 9 10.5ZM7.043 5.945c.168-.83.4-1.56.67-2.158C8.348 2.395 8.915 2.25 9 2.25c.086 0 .653.145 1.286 1.537.272.598.503 1.329.671 2.158a34.21 34.21 0 0 1-3.914 0Zm5.628 1.363a17.952 17.952 0 0 1 .033 2.986c1.069-.125 2.017-.3 2.8-.511l.207-.058a6.808 6.808 0 0 0-.309-2.87c-.805.189-1.726.343-2.731.453Zm2.08-1.844c-.68.145-1.45.267-2.29.357-.23-1.216-.59-2.285-1.042-3.124a6.773 6.773 0 0 1 3.332 2.767Zm-9.213.357c-.84-.09-1.61-.212-2.289-.357a6.773 6.773 0 0 1 3.332-2.767c-.452.838-.811 1.908-1.043 3.124Zm-2.94 1.034c.805.189 1.726.343 2.731.453a17.962 17.962 0 0 0-.033 2.986 19.804 19.804 0 0 1-2.8-.511 12.15 12.15 0 0 1-.208-.058 6.824 6.824 0 0 1 .31-2.87Zm8.821 8.448c.495-.92.88-2.116 1.106-3.48a23.625 23.625 0 0 0 2.796-.45 6.77 6.77 0 0 1-3.902 3.93Zm-4.838 0a6.77 6.77 0 0 1-3.902-3.93c.825.19 1.768.343 2.796.45.226 1.364.611 2.56 1.106 3.48ZM9 .75a8.25 8.25 0 1 1 0 16.5A8.25 8.25 0 0 1 9 .75Z","fill":"#B0B9C1"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    